import React from "react";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CustomerPriceListHeader = ({
  reloadList = () => {},
  bulkUpdateHandler = () => {},
  selectedCustomerIds = [],
  jsonFilterQuery = [],
}) => {
  const { t } = useTranslation();
  const breadcrumbText = [{ title: t("Marketplace") }];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* ------ refresh icon start ------ */}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            onClick={reloadList}
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* ------ refresh icon end ------ */}

          {/* --- action section start --- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCustomerIds.length === 0
                      ? "disabled text-muted"
                      : ""
                  }`}
                  data-bs-toggle={
                    selectedCustomerIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCustomerIds.length === 0
                      ? undefined
                      : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCustomerIds.length === 0
                      ? "disabled text-muted"
                      : ""
                  }`}
                  onClick={() => {
                    if (selectedCustomerIds.length > 0) {
                      bulkUpdateHandler();
                    }
                  }}
                >
                  <span className="material-symbols-outlined icon-sm">
                    refresh
                  </span>
                  <span className="d-block">{t("Bulk Update")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCustomerIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  data-bs-toggle={
                    selectedCustomerIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCustomerIds.length === 0
                      ? undefined
                      : "#deletewarning"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* --- action section end --- */}

          {/* ---- filter section start ---- */}
          {/* <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasPriceListFilter"
            aria-controls="offcanvasPriceListFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link> */}
          {/* ---- filter section end ---- */}
        </div>
      </div>
    </div>
  );
};

export default CustomerPriceListHeader;
